import React from 'react';

const McmPage = () => (
  <main className="min-h-screen bg-white pt-20">
    <section className="px-4 py-16 sm:py-24">
      <div className="mx-auto max-w-6xl text-center">
        <p
          aria-label="Mystic Circle"
          className="font-title text-5xl font-semibold uppercase leading-[0.92] tracking-wide text-fuchsia-600 sm:text-7xl lg:text-8xl"
        >
          MYSTIC CIRCLE
        </p>
        <p className="mt-2 text-right font-subtitle text-2xl font-light uppercase tracking-wide text-fuchsia-600 sm:mr-[8%] sm:text-4xl">
          MAGAZINE
        </p>
      </div>
    </section>

    <section className="bg-purple-800 px-4 py-16 text-purple-100 sm:py-24">
      <div className="mx-auto max-w-6xl">
        <h1 className="text-center font-title text-4xl text-purple-100 sm:text-6xl">
          Wisdom from Our Practitioners
        </h1>
        <div className="mx-auto mt-8 max-w-5xl space-y-6 font-body text-lg leading-relaxed text-purple-100 sm:text-xl">
          <p>
            Mystic Circle Magazine is the sacred publication of Mystic Temple, offering you direct
            access to real-world mysticism, advanced metaphysical teachings, and soul-deep guidance
            from the most trusted voices in the spiritual world.
          </p>
          <p>
            Featuring powerful contributions from Mystic University faculty, verified practitioners
            on The Wisdom Network, and select writings from The Divine Mother, Monica Bey, this
            magazine bridges the mystical and the practical in a way that speaks directly to the
            soul.
          </p>
          <p>
            From decoding daily signs to advanced esoteric practices, energy mastery, and personal
            transformation, this live feed delivers wisdom that speaks to both your human journey
            and your divine path. It delivers grounded wisdom, potent truths, and ever-expanding
            insight.
          </p>
        </div>
        <p className="mx-auto mt-10 max-w-5xl text-center font-subtitle text-sm font-bold uppercase tracking-wider text-purple-200 sm:text-base">
          NEW POSTS ADDED REGULARLY. Bookmark it. Share it. Return often. This is where real
          spiritual evolution lives.
        </p>
      </div>
    </section>
  </main>
);

export default McmPage;
